import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { blogPosts } from '../data/blogPosts';
import BlogCover from '../components/BlogCover';

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

function BlogCard({ post, colors }) {
  const [hovered, setHovered] = useState(false);
  return (
    <Link
      to={`/blog/${post.slug}`}
      style={{
        display: 'block', background: colors.surface, border: '1px solid',
        borderColor: hovered ? colors.text : colors.border,
        transform: hovered ? 'translateY(-4px)' : 'none',
        transition: 'all 0.3s', textDecoration: 'none', overflow: 'hidden',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <BlogCover cover={post.cover} height="170px" sizes="(max-width: 600px) 100vw, 480px" />
      <div style={{ padding: '1.5rem' }}>
        <div style={{
          fontFamily: "'JetBrains Mono', monospace", fontSize: '0.68rem',
          color: colors.muted, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '0.6rem',
        }}>
          {post.category} · {formatDate(post.date)}
        </div>
        <h3 style={{
          fontFamily: "'Inter', sans-serif", fontWeight: 800, fontSize: '1.3rem',
          letterSpacing: '0.5px', color: colors.text, marginBottom: '0.6rem', lineHeight: 1.15,
        }}>
          {post.title}
        </h3>
        <p style={{ fontSize: '0.85rem', color: colors.muted, lineHeight: 1.7, fontWeight: 300 }}>
          {post.excerpt}
        </p>
      </div>
    </Link>
  );
}

export default function BlogList() {
  const { colors } = useTheme();
  const sorted = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  const s = {
    section: { padding: '120px 5vw 80px', background: colors.bg, minHeight: '100vh' },
    back: {
      display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
      color: colors.muted, fontSize: '0.85rem', fontWeight: 600,
      letterSpacing: '0.5px', textDecoration: 'none', marginBottom: '2rem',
    },
    title: {
      fontFamily: "'Inter', sans-serif", fontWeight: 700,
      fontSize: 'clamp(2rem, 4vw, 3.5rem)',
      lineHeight: 1, letterSpacing: '2px', color: colors.heading, marginBottom: '3rem',
      textAlign: 'center',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
      gap: '1.5rem',
    },
  };

  return (
    <section style={s.section}>
      <Link to="/" style={s.back}>← Back to Home</Link>
      <h2 style={s.title}>ALL POSTS</h2>
      <div style={s.grid}>
        {sorted.map(post => <BlogCard key={post.slug} post={post} colors={colors} />)}
      </div>
    </section>
  );
}
